import IconButton from '@material-ui/core/IconButton'
import SendIcon from '@material-ui/icons/Send'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useChatDrawerStyles } from '../ChatDrawer.styles'
import VoiceChatButton from '../VoiceChatButton'
import { AdaChatTextField } from './AdaChatTextField'
import { AttachedFileIcon } from './AttachedFileIcon'
import { useChatContext } from './ChatContext'
import { hasUnuploadedFiles } from './utils/openAIFileUpload'

const ChatInput = () => {
  const context = useChatContext()
  const {
    messageText,
    setMessageText,
    onKeyDown,
    onSubmit,
    textInputEnabled,
    sendButtonEnabled,
    websocketAvailable,
    voiceSessionActive,
    placeholder,
    inputRef,
    attachedFiles,
    attachedFilesActions,
    isDragActive,
  } = context
  const classes = useChatDrawerStyles()
  const { tour } = useSelector((state: any) => state.tour)
  const isTourActive = tour === 'ada_chat'

  useEffect(() => {
    if (isTourActive) {
      setMessageText('')
      attachedFilesActions.clear()
    }
  }, [isTourActive, setMessageText, attachedFilesActions])

  const removeFile = (index: number) => {
    attachedFilesActions.remove(index)
  }

  const isSendButtonDisabled =
    (messageText.length === 0 && attachedFiles.length === 0) ||
    !textInputEnabled ||
    !sendButtonEnabled ||
    !websocketAvailable ||
    voiceSessionActive ||
    isTourActive ||
    hasUnuploadedFiles(attachedFiles)

  // Hide input when dragging files
  if (isDragActive) {
    return null
  }

  return (
    <div className={classes.inputContainer} id="Ada-Chat-Input">
      {attachedFiles.length > 0 && (
        <div className={classes.attachedFilesContainer}>
          {attachedFiles.map((attachedFile, index) => (
            <AttachedFileIcon key={index} attachedFile={attachedFile} onRemove={() => removeFile(index)} />
          ))}
        </div>
      )}
      <div className={classes.inputField}>
        <AdaChatTextField
          inputRef={inputRef}
          disabled={!textInputEnabled || voiceSessionActive || !websocketAvailable || isTourActive}
          placeholder={isDragActive ? '' : placeholder}
          variant="outlined"
          value={messageText}
          onChange={(event) => {
            setMessageText(event.target.value)
          }}
          onKeyDown={onKeyDown}
          multiline
          minRows={1}
          maxRows={4}
          fullWidth
          name="chat_message"
          id="chat_message"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="none"
          spellCheck={false}
          inputProps={{
            'data-lpignore': 'true',
            'data-1p-ignore': 'true',
            'data-bwignore': 'true',
            'data-form-type': 'other',
            'data-dashlane-ignore': 'true',
            autocomplete: 'off',
          }}
        />
        <div className={classes.voiceButton}>
          <VoiceChatButton disabled={!websocketAvailable || isTourActive} iconColor="inherit" />
        </div>
        <IconButton
          className={classes.sendButton}
          disabled={isSendButtonDisabled}
          onClick={onSubmit}
          aria-label="Send message"
        >
          <SendIcon fontSize="default" />
        </IconButton>
      </div>
    </div>
  )
}

export default ChatInput
